export interface InAppMessageDto {
  id: string;
  title: string;
  content: string;
  createdAt: string;
  expiresAt?: string;
  
  // Scheduling fields - when to show/hide the message
  showStartDate?: string;
  showEndDate?: string;
  
  priority: number;
  messageType: string;
  targetAudience?: string;
  targetRegions?: string;
  
  // User/Device specific targeting
  userId?: string;
  deviceId?: string;
  
  actionType?: string;
  actionData?: string;
  imageUrl?: string;
  metadata?: string;
  geoFenceData?: string;
  updatedAt: string;
}

export interface CreateInAppMessageRequest {
  title: string;
  content: string;
  expiresAt?: string;
  
  // Scheduling fields - when to show/hide the message
  showStartDate?: string;
  showEndDate?: string;
  
  priority: number;
  messageType: string;
  targetAudience?: string;
  targetRegions?: string;
  
  // User/Device specific targeting
  userId?: string;
  deviceId?: string;
  
  actionType?: string;
  actionData?: string;
  imageUrl?: string;
  metadata?: string;
  geoFenceData?: string;
}

export interface UpdateInAppMessageRequest {
  title: string;
  content: string;
  expiresAt?: string;
  
  // Scheduling fields - when to show/hide the message
  showStartDate?: string;
  showEndDate?: string;
  
  priority: number;
  messageType: string;
  targetAudience?: string;
  targetRegions?: string;
  
  // User/Device specific targeting
  userId?: string;
  deviceId?: string;
  
  actionType?: string;
  actionData?: string;
  imageUrl?: string;
  metadata?: string;
  geoFenceData?: string;
}

export interface MessageStatsResponse {
  totalActiveMessages: number;
  lastUpdated: string;
}

export const MESSAGE_TYPES = [
  'info',
  'warning',
  'alert',
  'promotion',
  'weather',
  'app_update',
  'volunteer'
] as const;

export const PRIORITY_LEVELS = [
  { value: 0, label: 'Low' },
  { value: 1, label: 'Normal' },
  { value: 2, label: 'High' },
  { value: 3, label: 'Urgent' }
] as const;

export const ACTION_TYPES = [
  'dismiss',
  'navigate',
  'url'
] as const;